module.exports = __webpack_public_path__ + "img/AI_1.12454ea4.png";